import Selector from "./components/Selector/Selector";
import { getLinks } from "./dataLinks";
import { fn } from "../../utils";
import "./App.scss";
import { AppProps } from "./App.types";

export default function App(props: AppProps) {
 const {
  logoProduct = "%logoProduct%",
  imageProduct = "%imageProduct%",
  linkRecipesWeb = "%linkRecipesWeb%",
  linkRecipesRobot = "%linkRecipesRobot%",
  linkContentInVideo = "%linkContentInVideo%",
  linkInstagram = "%linkInstagram%",
  linkManuals = "%linkManuals%",
  linkGuideFastStart = "%linkGuideFastStart%",
  linkMaintenanceGuide = "%linkMaintenanceGuide%",
  linkCecotecSupport = "%linkCecotecSupport%",
 } = props;

 const links = getLinks({
  linkRecipesWeb,
  linkRecipesRobot,
  linkContentInVideo,
  linkInstagram,
  linkManuals,
  linkGuideFastStart,
  linkMaintenanceGuide,
  linkCecotecSupport,
 });

 return (
  <div className="app landing">
   <div className="gradient" />

   <div className="header">
    {logoProduct && (
     <img src={logoProduct} className="img-logo" alt="img-logo" />
    )}
    {imageProduct && (
     <img src={imageProduct} className="img-product" alt="img-product" />
    )}
   </div>

   <div className="content">
    {links.map((item, index) => {
     if (!item.link) return null;

     return (
      <Selector
       key={index}
       {...item}
       className={fn.isValidUrl(item.link) ? "show" : ""}
      />
     );
    })}
   </div>

   <footer className="footer">
    <p className="text">www.cecotec.es</p>
   </footer>
  </div>
 );
}
